import { useEffect } from 'react';

/**
 * Disables scrolling on the body element, resetting when the component is unmounted
 */
export default function usePreventBodyScroll(): void {
  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return function resetBodyScroll() {
      document.body.style.overflow = 'initial';
    };
  }, []);
}
